(function () {
  'use strict';

  var app     = document.getElementById('gt-member-app');
  if (!app) return;

  var NETLIFY = app.dataset.netlify;

  var loading     = document.getElementById('gt-form-loading');
  var errorState  = document.getElementById('gt-form-error');
  var closedState = document.getElementById('gt-form-closed');
  var formWrap    = document.getElementById('gt-member-form-wrap');
  var successDiv = document.getElementById('gt-member-success');
  var msgEl      = document.getElementById('gt-member-msg');

  // ── Get form ID from URL ───────────────────────────────────────────────
  var formId  = new URLSearchParams(window.location.search).get('id');
  var currentCfg = null;
  if (!formId) { showError(); return; }

  // ── Fetch form config ─────────────────────────────────────────────────
  fetch(NETLIFY + '/get-bulk-form?id=' + encodeURIComponent(formId))
    .then(function (r) { return r.json().then(function (data) { return { status: r.status, data: data }; }); })
    .then(function (res) {
      if (res.status === 410) { showClosed(); return; }
      if (!res.data.success) { showError(); return; }
      currentCfg = res.data.form;
      renderForm(res.data.form);
    })
    .catch(showError);

  // ── Render member form ────────────────────────────────────────────────
  function renderForm(cfg) {
    // Header
    document.getElementById('gt-form-title').textContent    = cfg.form_name;
    document.getElementById('gt-form-chapter').textContent  = 'Chapter Bulk Order';

    // Deadline
    if (cfg.deadline) {
      var d = new Date(cfg.deadline + 'T12:00:00');
      document.getElementById('gt-deadline-text').textContent = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
      document.getElementById('gt-deadline-badge').hidden = false;
    }

    // Product info
    if (cfg.allow_partial_order && cfg.items && cfg.items.length > 1) {
      renderPartialOrder(cfg);
    } else {
      fetch('/products/' + cfg.product_handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) { renderProduct(product, cfg); })
        .catch(function () {
          document.getElementById('gt-product-title').textContent = cfg.product_title || '';
        });
    }

    // Member name/email fields
    if (!cfg.collect_name) document.getElementById('gt-member-name-wrap').hidden = true;
    if (cfg.collect_email) document.getElementById('gt-member-email-wrap').hidden = false;

    // Show form
    loading.hidden = true;
    formWrap.hidden = false;
  }

  // ── Render product and variant pickers ────────────────────────────────
  var currentProduct = null;

  function renderProduct(product, cfg) {
    currentProduct = product;

    document.getElementById('gt-product-title').textContent = product.title;
    document.getElementById('gt-product-price').textContent = formatMoney(product.variants[0].price);

    var img = product.images && product.images[0];
    if (img) {
      var imgEl = document.getElementById('gt-product-img');
      imgEl.src = img.src || img;
      imgEl.alt = product.title;
      imgEl.hidden = false;
    }

    // Build option selects for options that the merch head enabled
    var enabledOptions = cfg.options || [];
    var optionsCard    = document.getElementById('gt-options-card');
    var optionsFields  = document.getElementById('gt-options-fields');

    var realOptions = product.options.filter(function (o) {
      return o.name !== 'Title' && (enabledOptions.length === 0 || enabledOptions.indexOf(o.name) > -1);
    });

    if (!realOptions.length) { return; }

    optionsCard.hidden = false;
    realOptions.forEach(function (opt) {
      var field = document.createElement('div');
      field.className = 'gt-field';

      var label = document.createElement('label');
      label.className = 'gt-label';
      label.setAttribute('for', 'gt-opt-' + opt.position);
      label.textContent = opt.name;

      var select = document.createElement('select');
      select.className = 'gt-select';
      select.id = 'gt-opt-' + opt.position;
      select.dataset.optionName = opt.name;
      select.dataset.optionPos  = opt.position;

      var blank = document.createElement('option');
      blank.value = '';
      blank.textContent = '— Select ' + opt.name + ' —';
      select.appendChild(blank);

      opt.values.forEach(function (val) {
        var o = document.createElement('option');
        o.value = o.textContent = val;
        select.appendChild(o);
      });

      select.addEventListener('change', updateVariantAvailability);

      field.appendChild(label);

      var errSpan = document.createElement('span');
      errSpan.className = 'gt-field-err';
      errSpan.id = 'gt-opt-err-' + opt.position;

      field.appendChild(select);
      field.appendChild(errSpan);
      optionsFields.appendChild(field);
    });
  }

  // ── Partial order: render item checkboxes ─────────────────────────────
  var partialItemProducts = {}; // handle → product data

  function renderPartialOrder(cfg) {
    var itemsCard = document.getElementById('gt-items-card');
    var itemsList = document.getElementById('gt-items-list');
    if (!itemsCard || !itemsList) return;

    // Hide single-product display since we handle everything in items card
    document.getElementById('gt-product-info').hidden = true;
    itemsCard.hidden = false;

    cfg.items.forEach(function (item, idx) {
      var row = document.createElement('div');
      row.className = 'gt-partial-item';
      row.dataset.handle = item.product_handle;
      row.dataset.idx = idx;

      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.id = 'gt-item-check-' + idx;
      checkbox.className = 'gt-partial-item__check';
      checkbox.checked = true;

      var label = document.createElement('label');
      label.setAttribute('for', 'gt-item-check-' + idx);
      label.className = 'gt-partial-item__label';

      if (item.product_image) {
        var img = document.createElement('img');
        img.src = item.product_image;
        img.width = 48; img.height = 48;
        label.appendChild(img);
      }

      var info = document.createElement('div');
      info.className = 'gt-partial-item__info';

      var title = document.createElement('div');
      title.className = 'gt-partial-item__title';
      title.textContent = item.product_title || item.product_handle;
      info.appendChild(title);

      // Size selector placeholder (populated after product fetch)
      var sizeWrap = document.createElement('div');
      sizeWrap.className = 'gt-partial-item__options';
      sizeWrap.id = 'gt-item-opts-' + idx;
      info.appendChild(sizeWrap);

      label.appendChild(info);
      row.appendChild(checkbox);
      row.appendChild(label);
      itemsList.appendChild(row);

      // Toggle size visibility when unchecked
      checkbox.addEventListener('change', function () {
        sizeWrap.style.display = this.checked ? '' : 'none';
      });

      // Fetch live product data for size options
      fetch('/products/' + item.product_handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          partialItemProducts[item.product_handle] = product;
          renderPartialItemOptions(product, item, sizeWrap, idx);
        })
        .catch(function () {});
    });
  }

  function renderPartialItemOptions(product, cfgItem, container, idx) {
    var enabledOptions = cfgItem.options || [];
    var realOptions = product.options.filter(function (o) {
      return o.name !== 'Title' && (enabledOptions.length === 0 || enabledOptions.indexOf(o.name) > -1);
    });
    if (!realOptions.length) return;

    realOptions.forEach(function (opt) {
      var field = document.createElement('div');
      field.className = 'gt-field';

      var label = document.createElement('label');
      label.className = 'gt-label';
      label.setAttribute('for', 'gt-item-' + idx + '-opt-' + opt.position);
      label.textContent = opt.name;

      var select = document.createElement('select');
      select.className = 'gt-select';
      select.id = 'gt-item-' + idx + '-opt-' + opt.position;
      select.dataset.itemIdx = idx;
      select.dataset.itemHandle = cfgItem.product_handle;
      select.dataset.optionName = opt.name;
      select.dataset.optionPos  = opt.position;

      var blank = document.createElement('option');
      blank.value = '';
      blank.textContent = '— Select ' + opt.name + ' —';
      select.appendChild(blank);

      opt.values.forEach(function (val) {
        var o = document.createElement('option');
        o.value = o.textContent = val;
        select.appendChild(o);
      });

      var errSpan = document.createElement('span');
      errSpan.className = 'gt-field-err';
      errSpan.id = 'gt-item-' + idx + '-opt-err-' + opt.position;

      field.appendChild(label);
      field.appendChild(select);
      field.appendChild(errSpan);
      container.appendChild(field);
    });
  }

  function getCheckedItems(cfg) {
    var result = [];
    var rows = document.querySelectorAll('.gt-partial-item');
    rows.forEach(function (row) {
      var idx = parseInt(row.dataset.idx);
      var handle = row.dataset.handle;
      var check = row.querySelector('.gt-partial-item__check');
      if (!check || !check.checked) return;

      var cfgItem = cfg.items[idx];
      var product = partialItemProducts[handle];

      // Find variant
      var chosen = {};
      row.querySelectorAll('[data-option-pos]').forEach(function (s) {
        chosen[parseInt(s.dataset.optionPos)] = s.value;
      });

      var variant = null;
      if (product) {
        if (Object.keys(chosen).length) {
          variant = product.variants.find(function (v) {
            return Object.keys(chosen).every(function (pos) { return v['option' + pos] === chosen[pos]; });
          }) || null;
        } else {
          variant = product.variants[0];
        }
      }

      result.push({
        product_handle: handle,
        product_title: cfgItem ? cfgItem.product_title : handle,
        variant_id: variant ? variant.id : null,
        quantity: 1,
        properties: [],
      });
    });
    return result;
  }

  function getSelectedVariant() {
    if (!currentProduct) return null;
    var selects = document.querySelectorAll('[data-option-pos]');
    if (!selects.length) return currentProduct.variants[0];

    // Build a map of position → selected value (skip blank/unselected)
    var chosen = {};
    selects.forEach(function (s) { if (s.value) chosen[parseInt(s.dataset.optionPos)] = s.value; });
    if (!Object.keys(chosen).length) return null;

    return currentProduct.variants.find(function (v) {
      return Object.keys(chosen).every(function (pos) {
        return v['option' + pos] === chosen[pos];
      });
    }) || null;
  }

  function updateVariantAvailability() {
    var variant = getSelectedVariant();
    var priceEl = document.getElementById('gt-product-price');
    if (variant && priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    }
  }

  // ── Submit ────────────────────────────────────────────────────────────
  document.getElementById('gt-member-submit').addEventListener('click', function () {
    msgEl.className = 'gt-msg';

    var memberName  = document.getElementById('gt-member-name');
    var memberEmail = document.getElementById('gt-member-email');
    var nameErr     = document.getElementById('gt-member-name-err');
    var valid       = true;

    // Validate name
    if (memberName.offsetParent !== null && !memberName.value.trim()) {
      memberName.classList.add('is-invalid');
      nameErr.textContent = 'Please enter your name.';
      nameErr.classList.add('is-visible');
      valid = false;
    } else {
      memberName.classList.remove('is-invalid');
      nameErr.classList.remove('is-visible');
    }

    // Validate options
    document.querySelectorAll('[data-option-pos]').forEach(function (s) {
      var errEl = document.getElementById('gt-opt-err-' + s.dataset.optionPos);
      if (!s.value) {
        s.classList.add('is-invalid');
        if (errEl) { errEl.textContent = 'Please select a ' + s.dataset.optionName + '.'; errEl.classList.add('is-visible'); }
        valid = false;
      } else {
        s.classList.remove('is-invalid');
        if (errEl) errEl.classList.remove('is-visible');
      }
    });

    if (!valid) return;

    var variant = getSelectedVariant();
    var submitBtn = document.getElementById('gt-member-submit');
    submitBtn.classList.add('is-loading');
    submitBtn.disabled = true;

    // Build line item properties
    var props = [];
    if (memberName.value.trim()) props.push({ name: 'Member Name', value: memberName.value.trim() });
    if (memberEmail.value.trim()) props.push({ name: 'Member Email', value: memberEmail.value.trim() });
    if (currentCfg && currentCfg.org_name) props.push({ name: 'Sorority / Fraternity', value: currentCfg.org_name });

    var payload = {
      form_id:     formId,
      member_name: memberName.value.trim(),
      properties:  props,
    };

    // Partial order: send items array
    if (currentCfg && currentCfg.allow_partial_order && currentCfg.items && currentCfg.items.length > 1) {
      var checkedItems = getCheckedItems(currentCfg);
      if (!checkedItems.length) {
        msgEl.textContent = 'Please select at least one item.';
        msgEl.className = 'gt-msg gt-msg--error';
        submitBtn.classList.remove('is-loading');
        submitBtn.disabled = false;
        return;
      }
      // Attach member props to each item
      checkedItems.forEach(function (it) { it.properties = props; });
      payload.items = checkedItems;
    } else {
      payload.variant_id = variant ? variant.id : null;
      payload.quantity   = 1;
    }

    fetch(NETLIFY + '/submit-bulk-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function (r) { if (!r.ok) throw new Error('Server error ' + r.status); return r.json(); })
    .then(function (data) {
      if (!data.success) throw new Error(data.error || 'Submission failed.');
      formWrap.hidden = true;
      document.getElementById('gt-success-msg').textContent =
        'Your order has been added. The person in charge of your order will let you know when items are ready!';
      successDiv.hidden = false;
    })
    .catch(function (err) {
      msgEl.textContent = err.message || 'Something went wrong — please try again.';
      msgEl.className = 'gt-msg gt-msg--error';
      submitBtn.classList.remove('is-loading');
      submitBtn.disabled = false;
    });
  });

  // ── Helpers ───────────────────────────────────────────────────────────
  function showError() {
    loading.hidden = true;
    errorState.style.display = 'block';
  }

  function showClosed() {
    loading.hidden = true;
    closedState.style.display = 'block';
  }

  function formatMoney(price) {
    // Shopify prices are in cents (e.g. 5500 = $55.00)
    return '$' + (parseFloat(price || 0) / 100).toFixed(2);
  }
})();
